import { render, staticRenderFns } from "./ElementWeightPlanTableColumn.vue?vue&type=template&id=1b820f1a"
import script from "./ElementWeightPlanTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementWeightPlanTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports